import { useUserFutureMessageCount, useUserFutureMessages } from 'api/goodtrust/user/futureMessage'
import { Button } from 'components/button/Button'
import { FutureMessageCard } from 'components/futureMessage/futureMessageCard/FutureMessageCard'
import { useFutureMessageTemplateModalWithRedirectParams } from 'components/futureMessage/futureMessageTemplateModal/FutureMessageTemplateModal'
import { SectionEmptyState } from 'components/sectionEmptyState/SectionEmptyState'
import { Spacer } from 'components/spacer/Spacer'
import { WizardCardBigGrid4 } from 'components/wizard/wizardCardItem/WizardCardItem'
import { WizardContentHeading } from 'components/wizard/wizardContent/WizardContent'
import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'
import { getPaginationMeta } from 'utils/pagination'

export const FutureMessagesContent = () => {
  const { t: tCommon } = useTranslation()
  const { t } = useTranslation('life_stories')
  const [templateModal, openTemplateModal] = useFutureMessageTemplateModalWithRedirectParams()

  const futureMessageList = useUserFutureMessages({ hasParent: false })
  const meta = getPaginationMeta(futureMessageList)

  const { mutate: mutateUserFutureMessageCount } = useUserFutureMessageCount()

  const sharedFutureMessageList = useUserFutureMessages({
    hasParent: true,
  })
  const sharedMeta = getPaginationMeta(sharedFutureMessageList)

  return (
    <>
      {templateModal}
      <section>
        {meta.isEmpty ? (
          <SectionEmptyState
            icon="Send"
            title={t('life_stories.inside_page.future_messages.empty_title')}
            description={t('life_stories.inside_page.future_messages.empty_desc')}
            buttons={
              <Button onClick={() => openTemplateModal({ type: 'dashboard' })} type="button">
                {t('life_stories.inside_page.future_messages.empty_action_button')}
              </Button>
            }
          />
        ) : (
          !meta.isLoadingInitial && (
            <>
              <WizardCardBigGrid4 css={{ marginTop: '1rem' }} autoFill>
                {futureMessageList.data?.map((page, pageIndex) => (
                  <Fragment key={pageIndex}>
                    {page?.json?.items?.map((item) => {
                      return (
                        <FutureMessageCard
                          futureMessage={item}
                          key={item.uuid}
                          onDataChange={async () => {
                            await futureMessageList.mutate()
                            await mutateUserFutureMessageCount()
                          }}
                        />
                      )
                    })}
                  </Fragment>
                ))}
              </WizardCardBigGrid4>

              {!meta.isReachingEnd && (
                <>
                  <Spacer size={1} />
                  <Button
                    type="button"
                    variant="secondary"
                    size="large"
                    block
                    loading={meta.isLoadingMore}
                    onClick={meta.handleLoadMore}
                    data-testid="load-more-button"
                  >
                    {tCommon('common.load_more')}
                  </Button>
                </>
              )}
            </>
          )
        )}
      </section>

      <section>
        {(sharedMeta.isLoadingInitial || !sharedMeta.isEmpty) && (
          <>
            <WizardContentHeading
              css={{ marginTop: '2rem' }}
              title={t('life_stories.inside_page.banners.future_messages.shared_with_me_title')}
            />
            <WizardCardBigGrid4 autoFill>
              {sharedFutureMessageList.data?.map((page, pageIndex) => (
                <Fragment key={pageIndex}>
                  {page?.json?.items?.slice(0, 2).map((item) => {
                    return (
                      <FutureMessageCard
                        futureMessage={item}
                        key={item.uuid}
                        onDataChange={sharedFutureMessageList.mutate}
                      />
                    )
                  })}
                </Fragment>
              ))}
            </WizardCardBigGrid4>

            {!sharedMeta.isReachingEnd && (
              <>
                <Spacer size={1} />
                <Button
                  type="button"
                  variant="secondary"
                  size="large"
                  block
                  loading={sharedMeta.isLoadingMore}
                  onClick={sharedMeta.handleLoadMore}
                >
                  {tCommon('common.load_more')}
                </Button>
              </>
            )}
          </>
        )}
      </section>
    </>
  )
}

export const FutureMessagesAction = () => {
  const { t } = useTranslation('life_stories')
  const [templateModal, openTemplateModal] = useFutureMessageTemplateModalWithRedirectParams()

  return (
    <>
      {templateModal}
      <Button
        type="button"
        variant="text"
        data-testid="gallery-upload-photo"
        onClick={() => openTemplateModal({ type: 'dashboard' })}
      >
        {t('life_stories.inside_page.future_messages.action_card_button')}
      </Button>
    </>
  )
}
